import React from "react";
import { X } from "lucide-react";
import OfficeLocationsForm from "./OfficeLocationsForm";

const OfficeLocationsModal = ({
    isOpen,
    onClose,
    businessInfoId,
    initialData,
    token,
    onRefreshAccounts,
    onSave
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl mx-auto relative max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between border-b border-gray-200 px-6 py-1">
                    <h2 className="text-lg font-semibold text-gray-900">
                        Manage Office Locations
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="p-6">
                    <OfficeLocationsForm
                        businessInfoId={businessInfoId}
                        initialData={initialData}
                        onRefreshAccounts={onRefreshAccounts}
                        token={token}
                        onSave={(updated) => {
                            onSave(updated);
                            onClose(); 
                        }}
                        onCancel={onClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default OfficeLocationsModal;
